var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descBox boxBg"},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.desc)?_c('h3',{domProps:{"innerHTML":_vm._s(_vm.desc)}}):_vm._e(),_c('div',{staticClass:"iconBox"},[(_vm.isCodeIcon)?_c('span',{staticClass:"codeIcon"},[_c('img',{attrs:{"src":require("../assets/code.png"),"alt":""}})]):_vm._e(),_c('span',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(
        function () {

          var noBr = _vm.desc.replace(/<br>/gm,'')

          _vm.notify();
      
          return  noBr ;
        }
      ),expression:"\n        () => {\n\n          let noBr = desc.replace(/<br>/gm,'')\n\n          notify();\n      \n          return  noBr ;\n        }\n      "}],staticClass:"copyIcon"},[_c('img',{attrs:{"src":require("../assets/copy.png"),"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }